var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTxtpic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490 490",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "132.668,309.465 154.441,309.465 154.441,372.031 168.737,372.031 168.737,309.465 191.257,309.465  191.257,296.665 132.668,296.665  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.987,296.665H245.09l-10.049,16.838c-1.764,2.946-3.23,5.563-4.411,7.836l-1.376,2.602 c-0.299,0.583-0.763,1.466-1.391,2.647h-0.209l-1.376-2.647l-1.391-2.662c-1.391-2.572-2.886-5.189-4.471-7.836l-10.049-16.778 h-17.062l22.969,36.487l-24.733,38.879h17.227l10.871-18.109c2.437-4.007,4.606-7.821,6.52-11.439l1.6-2.976h0.224l1.6,2.931 l1.54,2.976c1.525,2.871,3.11,5.712,4.755,8.509l10.826,18.109h16.778l-24.135-38.879L261.987,296.665z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.707,309.465 285.465,309.465 285.465,372.031 299.76,372.031 299.76,309.465 322.31,309.465 322.31,296.665  263.707,296.665  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.788,0v265.111H42.189v139.615h0.001l35.59,35.591L77.788,490h370.023V102.422L345.388,0H77.788z M395.793,389.413 H57.501v-108.99h338.292V389.413z M353.022,36.962l57.816,57.804h-57.816V36.962z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxtpic);
export default __webpack_public_path__ + "static/media/txtpic.4239af0a151572b5980dd6f8c89b1bbf.svg";
export { ForwardRef as ReactComponent };